import { computed, ref } from 'vue'
import { getWebsiteProductConfig } from '@/api/trade'

const config = ref({})
const loading = ref(false)
const loaded = ref(false)
const error = ref('')
let loadPromise = null

function money(value) {
  return `¥${Number(value || 0).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`
}

async function loadProductConfig(force = false) {
  if (!force && (loaded.value || loadPromise)) return loadPromise

  loading.value = true
  error.value = ''
  loadPromise = getWebsiteProductConfig()
    .then(result => {
      config.value = result || {}
      loaded.value = true
      return config.value
    })
    .catch(err => {
      error.value = err?.message || '商品信息加载失败，请稍后重试'
      throw err
    })
    .finally(() => {
      loading.value = false
      loadPromise = null
    })
  return loadPromise
}

export function useWebsiteProductConfig() {
  const priceText = computed(() => {
    if (loading.value && !loaded.value) return '获取价格中...'
    if (config.value.priceHidden === true) return '价格以确认订单为准'
    return money(config.value.unitPrice)
  })

  const freightText = computed(() => {
    const freight = Number(config.value.freightAmount || 0)
    return freight > 0 ? `运费 ${money(freight)}` : '免运费'
  })

  const productSummary = computed(() => [
    config.value.productType,
    config.value.servicePeriod,
    config.value.giftComputePower
  ].filter(Boolean).join(' · '))

  const productIncludes = computed(() => String(config.value.includesText || '')
    .split(/\r?\n/)
    .map(item => item.trim())
    .filter(Boolean))

  const productMetrics = computed(() => [
    { label: '商品形态', value: config.value.productType },
    { label: '服务周期', value: config.value.servicePeriod },
    { label: '赠送资源', value: config.value.giftComputePower }
  ].filter(item => item.value))

  return {
    productConfig: config,
    productConfigLoading: loading,
    productConfigLoaded: loaded,
    productConfigError: error,
    loadProductConfig,
    priceText,
    freightText,
    productSummary,
    productIncludes,
    productMetrics
  }
}
